export default __webpack_public_path__ + "dist/media/Create.d1b0cee3.png";